import React from 'react';
import AdditionalStatsContentContainer from '../../shared/components/AdditionalStatsContentContainer';
import StatsElement from '../../../../shared/entities/stats-element/components/StatsElement';
import { StatsElementType } from '../../../../shared/entities/stats-element/enums/StatsElementType';
import AdditionalStatsPage from '../AdditionalStatsPage';

const GLOBAL_LARGEST_IPOS_FOOTNOTE =
  'Deal size amounts do not reflect any exercise of the underwriter overallotment (greenshoe). ' +
  'All deal sizes are nominal amounts without adjustment for inflation. Non-US listings convert to USD ' +
  'using the FX rate at the time of the offering. For Agricultural Bank of China, Industrial & Commercial ' +
  'Bank of China (ICBC), and Bank of China, we count the H-share (Hong Kong) and A-share (Shanghai) ' +
  'offerings separately; combining them would result in AgBank raising $19.2 billion, ICBC raising ' +
  '$19.1 billion, and Bank of China raising $10.7 billion.';

const LargestGlobalIPOs: React.FC = () => {
  return (
    <AdditionalStatsPage>
      <AdditionalStatsContentContainer title="Largest Global IPOs">
        <StatsElement
          type={StatsElementType.LargestIPOsGlobal}
          options={{ viewGridOptions: { 0: { footnote: GLOBAL_LARGEST_IPOS_FOOTNOTE } } }}
        />
      </AdditionalStatsContentContainer>
    </AdditionalStatsPage>
  );
};

export default LargestGlobalIPOs;
